module.exports = __webpack_public_path__ + "img/application-form-management.7460283e.svg";